import React from 'react';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { purchaseUrl } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const included = ['5 Módulos completos: Evaluación, Limpieza, Extracciones, Protocolos por piel y Recurrencia', 'BONO 1 — Manual de 40 Situaciones Difíciles (gratis)', 'BONO 2 — Kit de Cabina: 15 Fichas Profesionales (gratis)', 'BONO 3 — 50 Protocolos Prácticos (gratis)', 'Garantía de 7 días'];
export function Pricing() {
  return <section id="pricing" className="scroll-mt-20 bg-canvas px-4 py-14 md:py-16" aria-labelledby="pricing-title" data-id="element-204" data-mp="6bwc9p0zpzi7">
      <div className="mx-auto max-w-2xl text-center" data-id="element-205" data-mp="ab57yzflc7ge">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-primary md:text-sm" data-id="element-206" data-mp="2r0u4hgq2qxwr">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-207" data-mp="2v0ujb2h35b4c">
          <Countdown data-id="element-208" data-mp="2fn2ndfi51115" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-209" data-mp="2fodrxhjeqctb">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-210" data-mp="2oo0tq4g1tkmw" />
          Después sube $9.990 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-primary bg-white p-6 text-left shadow-[0_24px_60px_rgba(27,94,63,.20)] md:p-9" data-id="element-211" data-mp="2km5tz4drnfb8">
          <div className="text-center" data-id="element-212" data-mp="2ykvpwgoun8y0">
            <span className="inline-flex rounded-full bg-primary px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-213" data-mp="2tnde8ijg6fmb">
              🔥 Precio especial de lanzamiento
            </span>
            <h2 id="pricing-title" className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-214" data-mp="33df5tkb0eg5z">
              Acceso a los 5 módulos + 3 bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-line py-6" data-id="element-215" data-mp="3halj4zcyrmnt">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-216" data-mp="2a0fhm5bbk519">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-217" data-mp="2eza87tfj2xvx" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-218" data-mp="2izkcn1no9g8o">
            <p className="text-base font-bold text-slate-400 line-through" data-id="element-219" data-mp="2nrtxi39xjq43">$57.990</p>
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-220" data-mp="2nty8t6a5rree">Hoy</p>
            <p className="text-4xl font-black text-primary md:text-6xl" data-id="element-221" data-mp="2staxzxoi5ak5">$19.990 ARS</p>
            <p className="mt-2 inline-flex rounded-full bg-accent px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-222" data-mp="2xo6tj7sy6g20">
              66% OFF
            </p>
            <div className="mt-6" data-id="element-223" data-mp="36pephj7zr4sx">
              <Button href={purchaseUrl} fullWidth className="text-sm md:text-lg" data-id="element-224" data-mp="36odch97f088k">
                🧴 QUIERO MI FACIAL PRO AHORA →
              </Button>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-225" data-mp="1cd6yggysj82f">
              <span className="flex items-center gap-1" data-id="element-226" data-mp="14v0cgloeetoj">
                <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-227" data-mp="101nugue85l4r" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-228" data-mp="v3w07tq3xmxe">
                <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-229" data-mp="r2asemsfjyu2" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-230" data-mp="1nsjpe0dz8wg8">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-231" data-mp="1npxj042tomzl" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-232" data-mp="1ir45wcrg6xzy">
                <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-233" data-mp="1eq0p9o1ksxxo" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}